import { styled } from '@mui/material';

export const ReviewContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1.5),
  },
}));
